export default __webpack_public_path__ + "static/media/icone-info-step1.0c66e0bf.svg";